import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import ClaimFormPage from "./pages/ClaimFormPage";
import ClaimsQueuePage from "./pages/ClaimsQueuePage";
import ApprovalPage from "./pages/ApprovalPage";
import AdminPage from "./pages/AdminPage";
import HotspotPage from "./pages/HotspotPage";
import PoliciesPage from "./pages/PoliciesPage";
import NotificationsPage from "./pages/NotificationsPage";

const LoginRoute = () => {
  const { user } = useAuth();
  if (user === null) return null;
  if (user) return <Navigate to="/" replace />;
  return <LoginPage />;
};

const RoleRoute = ({ roles, children }) => {
  const { user } = useAuth();
  if (user && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginRoute />} />
            <Route element={<Layout />}>
              <Route path="/" element={<DashboardPage />} />
              <Route path="/klaim/baru" element={<RoleRoute roles={["admin", "supervisor", "staff"]}><ClaimFormPage /></RoleRoute>} />
              <Route path="/klaim" element={<ClaimsQueuePage />} />
              <Route path="/approval" element={<RoleRoute roles={["admin", "supervisor"]}><ApprovalPage /></RoleRoute>} />
              <Route path="/admin" element={<RoleRoute roles={["admin"]}><AdminPage /></RoleRoute>} />
              <Route path="/notifikasi" element={<RoleRoute roles={["admin"]}><NotificationsPage /></RoleRoute>} />
              <Route path="/hotspot" element={<RoleRoute roles={["admin", "supervisor", "staff"]}><HotspotPage /></RoleRoute>} />
              <Route path="/polis" element={<RoleRoute roles={["admin", "supervisor", "staff"]}><PoliciesPage /></RoleRoute>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
